import { CloseOutlined } from "@ant-design/icons";
import { Button, Collapse, Form, Input, Space } from "antd";
import React from "react";
import { CustomParamsInput } from "../CustomParamsInput";
import { ViewComponentTypeSelect } from "./ViewComponentTypeSelect";
import { LayoutConstraintList } from "../Layout/LayoutConstraintList";
import { Appearance } from "./Appearance";
import { ViewComponent, initialViewComponent } from "../../types";

interface ViewComponentProps {
  name: string | number | (string | number)[];
  views?: ViewComponent[];
  components_names?: string[];
}

export const ViewComponentList = (props: ViewComponentProps) => {
  const newComponent = (): ViewComponent => {
    let name = "component";
    if (props.name instanceof Array) {
      name = props.name.reverse().join("-");
    }
    return {
      ...initialViewComponent,
      name: name,
    };
  };

  return (
    <Form.List name={props.name}>
      {(fields, { add, remove }) => (
        <div style={{ display: "flex", rowGap: 16, flexDirection: "column" }}>
          {fields.map((field, index) => (
            <Collapse size="small" key={field.key}>
              <Collapse.Panel
                key={field.name}
                header={"View Component " + props.views?.[index].name}
                extra={
                  <CloseOutlined
                    
                    onClick={() => {
                      remove(field.name);
                    }}
                  />
                }
              >
                <Space direction="horizontal" size="middle">
                  <Form.Item label="Name" name={[field.name, "name"]}>
                    <Input />
                  </Form.Item>
                  <Form.Item
                    style={{ minWidth: "250px" }}
                    label="Type"
                    name={[field.name, "type"]}
                  >
                    <ViewComponentTypeSelect />
                  </Form.Item>
                </Space>
                <Form.Item label="Source" name={[field.name, "source"]}>
                  <Input.TextArea rows={3} />
                </Form.Item>
                <Form.Item
                  label="Placeholder"
                  name={[field.name, "placeholder"]}
                >
                  <Input.TextArea rows={1} />
                </Form.Item>
                <Form.Item name={[field.name, "appearance"]}>
                  <Appearance name={[field.name, "appearance"]} />
                </Form.Item>
                <Form.Item label="Layout">
                  <LayoutConstraintList
                    components={props.components_names}
                    name={[field.name, "layout", "constraints"]}
                    constraints={props.views?.[index].layout.constraints}
                  />
                </Form.Item>
                <Form.Item label="Custom Parameters" name="custom_params">
                  <CustomParamsInput />
                </Form.Item>
              </Collapse.Panel>
            </Collapse>
          ))}

          <Button type="dashed" onClick={() => add(newComponent())} block>
            + Add View Component
          </Button>
        </div>
      )}
    </Form.List>
  );
};
